import React from "react";
import { Box, Flex, Heading, Image } from "@chakra-ui/react";

type HeroProps = {
  title: string;
  image?: string | React.ReactNode;
  layout?: "vertical" | "horizontal";
  mobileLayout?: "vertical" | "horizontal";
  center?: boolean;
  children: React.ReactNode;
};

const Hero = ({
  title,
  image,
  layout = "horizontal",
  mobileLayout = "horizontal",
  center,
  children,
}: HeroProps) => {
  const isHoriztonal = layout === "horizontal";
  const mobileIsHoriztonal = mobileLayout === "horizontal";
  return (
    <Flex
      flexDirection={{
        base: isHoriztonal
          ? !mobileIsHoriztonal
            ? "column-reverse"
            : "row-reverse"
          : "column",
        md: isHoriztonal ? "row-reverse" : "column",
      }}
      justifyContent={"space-between"}
      alignItems={{ base: center ? "center" : "flex-start", md: "center" }}
      mb="24px"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        mb={isHoriztonal ? "0" : "4"}
        mt={{ base: isHoriztonal ? "10" : "0", md: "0" }}
      >
        {image && typeof image === "string" ? <Image src={image} /> : image}
      </Flex>
      <Box
        w="100%"
        textAlign={{
          base: center ? "center" : "left",
          md: isHoriztonal ? "left" : "center",
        }}
      >
        <Heading as="h1" variant="heading1">
          {title}
        </Heading>
        <Box
          maxW={{ base: "100%", md: isHoriztonal ? "50%" : "55%" }}
          margin={isHoriztonal ? "0" : "0 auto"}
        >
          {children}
        </Box>
      </Box>
    </Flex>
  );
};

export default Hero;
